import React, { createContext, useEffect, useState, useMemo } from 'react'
import { useUser } from '@fs/zion-user'
import { correctionalFacilityId } from '@fs/zion-config'
import axios from '@fs/zion-axios'

export const PrisonContext = createContext({})

export const PrisonProvider = ({ children }) => {
  const [facility, setFacility] = useState(null)
  const [isInmate, setIsInmate] = useState(false)
  const [inmateChecked, setInmateChecked] = useState(false)
  const [isReady, setIsReady] = useState(false)
  const { signedIn, userLoading } = useUser()

  /**
   * Check if the user is an inmate.
   * */
  useEffect(() => {
    const checkIfUserIsInmate = async () => {
      try {
        const resp = await axios.get('/service/volunteer/edge/profile/users/facility')
        setFacility(resp?.data || {})
        setIsInmate(resp?.status === 200)
      } catch (err) {
        console.error(err)
      } finally {
        setInmateChecked(true)
        setIsReady(true)
      }
    }
    if (!userLoading) {
      if (signedIn && !inmateChecked) {
        checkIfUserIsInmate()
      } else {
        setIsReady(true)
        setInmateChecked(true)
      }
    }
  }, [signedIn, userLoading, inmateChecked])

  const accessFromPrison = typeof correctionalFacilityId === 'string' && correctionalFacilityId.length > 0

  const contextValue = useMemo(
    () => ({
      accessFromPrison,
      facility,
      isInmate,
      isReady,
    }),
    [accessFromPrison, facility, isInmate, isReady]
  )

  return <PrisonContext.Provider value={contextValue}>{children}</PrisonContext.Provider>
}
